import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SolutionsPage from "./pages/SolutionsPage";
import QdApp from "./quote/QdApp";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/sprendimai-bibliotekoms" element={<SolutionsPage />} />
          {/* Quote Module - Private */}
          <Route path="/quote/*" element={<QdApp />} />
          {/* 301 Redirects for old WordPress English URLs */}
          <Route path="/en" element={<Navigate to="/" replace />} />
          <Route path="/en/*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
